export const colors: string[] = [
  '#2b5876',
  '#00d6bf',
  '#5580a5',
  '#68ada2',
  '#7ea3c0',
  '#4a8877',
  '#00b4fd',
  '#00a86e',
  '#fdbd00',
  '#fd5861',
]
